module.exports = __webpack_public_path__ + "img/footer-logo-skroutz-lm.35bebe4e.svg";